import { Breadcrumbs } from "../breadcrumbs";
import {
	MembersTable,
	PaginatedMembersTableProvider,
} from "../tables/members-table";

export function MembersPage() {
	return (
		<PaginatedMembersTableProvider>
			<div className="space-y-2">
				<Breadcrumbs />
				<div className="flex flex-col">
					<div className="flex justify-between">
						<h2>Members</h2>
					</div>
					<MembersTable />
				</div>
			</div>
		</PaginatedMembersTableProvider>
	);
}
